export function CtaSection() {
  return (
    <section className="w-full px-4 py-12 bg-gray-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-6">
          Tu próxima aventura está a un clic de distancia.
        </h2>
        
        <p className="text-xl text-gray-600 mb-8">
          No esperes más para vivir momentos únicos en lugares increíbles. Elige tu destino, prepárate para desconectar y crea recuerdos inolvidables. ¿Estás listo para empezar?
        </p>

        <a
          href="https://wa.me/34648728151"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-green-500 hover:bg-green-600 text-white px-8 py-3 rounded-lg text-lg transition-colors"
        >
          Reserva por WhatsApp
        </a>
      </div>
    </section>
  );
}
